module.exports = __webpack_public_path__ + "img/payroll03.e7aa0cd2.jpeg";